export default __webpack_public_path__ + "static/media/speed_rail.9f341b9f.png";